import { render, staticRenderFns } from "./EditFAQButton.vue?vue&type=template&id=e00a525e&"
import script from "./EditFAQButton.vue?vue&type=script&lang=js&"
export * from "./EditFAQButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports